import React from 'react'

type Props = {
    children?: React.ReactNode;
}

const PageTitleText = (props: Props) => {
    return (
        <h1 className="pt-2 font-bold text-white text-center md:text-left text-[22px] md:text-[22px]">
            {props.children}
        </h1>
    )
}

export default PageTitleText